/**
 * Created by rodrigo on 6/19/17.
 */

export const ACTIONS = {
  LOGOUT: 'logout/LOGOUT',
}

export default ACTIONS;
